import './App.css';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Switch, Route, useLocation } from 'react-router-dom';
import React, { useReducer, useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { UserContext } from './contexts/userContext';
import NotFound from './items/404/NotFound';
import PaymentPrompt from './machineUI/paymentPrompt';
import ProductDispense from './machineUI/productDispense';
import EmailCode from './machineUI/EmailCode';
import MachineSignIn from './auth/MachineSignIn';
import ImageSlider from './machineUI/items/ImageSlider';
import IdleTimer from './machineUI/items/IdleTimer';
import Initial from './machineUI/items/Initial';
import Logout from './auth/Logout';
import Synch from './items/Synch';
import Home from './machineUI/home';
import CategoryPage from './machineUI/Category/CategoryPage';
import Disability from './machineUI/items/Disability';

import OutOfOrder from './machineUI/outOfOrder';
import DescriptionPage from './machineUI/Description/DescPage';
import CartFullModal from './machineUI/items/CartFullModal';
import request from './services/Request';
// import { defaultStat } from '../src/staticData/stats';
import { setVariable } from './services/servicesFunc';
import SelectPayment from './machineUI/SelectPayment';
import CashPayment from './machineUI/CashPayment';
import { outOfOrderRequest } from './machineUI/outOfOrderRequest';
import localRequest from './services/LocalServer/localRequest';
import p from '../package.json';
import { publicIpv4 } from 'public-ip';

const LOCAL_STORAGE_KEY = 'MagexApp.cart';
const MAXCARTNUM = 3;

function App() {
  const location = useLocation();
  const [cartQuantity, setCartQuantity] = useState(0);

  //restore user information from localstorage
  const loggedInUser = JSON.parse(localStorage.getItem('user'));
  let initialState = { login: false, userName: '', role: '', email: '' };
  if (loggedInUser) {
    initialState.login = true;
    initialState.userName = loggedInUser.firstname;
    initialState.role = loggedInUser.role;
    initialState.email = loggedInUser.email;
    initialState.referTo = loggedInUser.referTo;
    initialState.fullAccess = loggedInUser.fullAccess;
    initialState.limits = loggedInUser.limits;
  }

  //user state
  const [loginStatus, setLoginStatus] = useState(initialState.login);
  const [user, setUser] = useState(initialState);
  const [userName, setUserName] = useState(initialState.userName);
  const [role, setRole] = useState(initialState.role);
  const [userEmail, setUserEmail] = useState(initialState.email);
  const [referTo, setReferTo] = useState(initialState.referTo);
  const [fullAccess, setFullAccess] = useState(initialState.fullAccess);
  //for checkout and cart
  const [machineID, setMachineID] = useState('');
  const [machine, setMachine] = useState(null);
  const [testMode, setTestMode] = useState(false);
  const [langs, setlangs] = useState('en');
  const [cartFull, setCartFull] = useState(false);

  //for initial category page
  const [idle, setIdle] = useState(0);

  const [showCart, setShowCart] = useState(false);
  const [products, setProds] = useReducer(productsReducer, []);

  const defaultStat = {
    session_com: 0,
    cart_aband: 0,
    all_prod: 0,
    all_brand: 0,
    payment: 0,
    language: {
      en: 0,
      fr: 0,
      es: 0,
    },
    cart_page: 0,
    faq: 0,
    cate: [],
    prod: [],
    brand: [],
    banner: {},
    session_time: 0,
    time: new Date(),
  };

  const [stat, setStat] = useState(defaultStat);
  const [cart, setCart] = useReducer(cartReducer, []);
  const [linkPromo, setLinkPromo] = useState({ p: '', id: '' });

  //for hosting preview site

  useEffect(() => {
    if (process.env.REACT_APP_DEV === 'TRUE') {
      localStorage.setItem('ISLOCAL', 'FALSE');
    }
  }, []);

  //always check oos status
  useEffect(() => {
    const runSet = async () => {
      await setVariable();
    };

    runSet();
    const mid = localStorage.getItem('machineID');
    if (mid) {
      var outInterval = setInterval(() => outOfOrderRequest(outInterval, mid), 2000);
    }
    return () => {
      clearInterval(outInterval);
    };
  }, []);

  useEffect(() => {
    const productsStock = JSON.parse(localStorage.getItem('products'));
    if (productsStock) {
      setProds({ productsStock, type: 'set' });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('products', JSON.stringify(products));
  }, [products]);

  useEffect(() => {
    if (showCart) {
      stat.cart_page += 1;
      setStat(stat);
    }
  }, [showCart]);

  function productsReducer(state, action) {
    switch (action.type) {
      case 'set':
        return [...action.productsStock];
      case 'add':
        return [...action.product];
      case 'clean': {
        const update = [];
        return update;
      }
      case 'decrement': {
        const productIndex = state.findIndex((item) => item._id === action.product._id);
        if (productIndex < 0) {
          return state;
        }
        if (cartQuantity < MAXCARTNUM || action.product.current_stock < action.qtt) {
          const update = [...state];
          update[productIndex].current_stock = action.qtt;
          return update;
        }
      }
      default:
        return state;
    }
  }

  function decreStock(product, qtt) {
    setProds({ product, qtt, type: 'decrement' });
  }

  function setAllProds(product) {
    setProds({ product, type: 'add' });
  }

  function changeProdPrice(product) {
    setCart({ product, type: 'changeProdPrice' });
  }

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    if (storedCart) {
      setCart({ storedCart, type: 'addArray' });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cart));
    const totalQtt = cart.reduce((total, item) => {
      return (total += item.quantity);
    }, 0);
    setCartQuantity(totalQtt);
  }, [cart]);

  //send web application status to database
  useEffect(() => {
    if (!(process.env.REACT_APP_DEV === 'TRUE')) {
      var interval = setInterval(() => updateActive(), 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);
  const updateActive = async () => {
    const mid = localStorage.getItem('machineID');
    if (mid) {
      let version = '0.0.0';
      localRequest({
        method: 'get',
        url: `/getVersion`,
        timeout: 1000,
      })
        .then(async (res) => {
          const IP = await publicIpv4();
          version = res.data.version;
          version = p.version + ' + ' + version;
          request({
            method: 'post',
            url: `/machines/updateStatus`,
            data: {
              id: mid,
              version: version,
              ip: IP,
            },
          }).then((res) => {});
        })
        .catch(() => {
          request({
            method: 'post',
            url: `/machines/updateStatus`,
            data: {
              id: mid,
            },
          }).then((res) => {});
        });
      console.log('update active');
    }
  };

  function cartReducer(state, action) {
    switch (action.type) {
      case 'addArray': {
        return [...action.storedCart];
      }
      case 'add': {
        if (cartQuantity >= MAXCARTNUM) {
          setCartFull(true);
          return state;
        } else {
          return [...state, action.product];
        }
      }
      case 'remove': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update.splice(productIndex, 1);
        return update;
      }
      case 'chgQuantity': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        if (cartQuantity >= MAXCARTNUM && state[productIndex].quantity < action.quantity) {
          setCartFull(true);
          return state;
        } else {
          const update = [...state];
          update[productIndex].quantity = action.quantity;
          return update;
        }
      }
      case 'changePrice': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update[productIndex].discount = action.discount;
        update[productIndex].discountedPrice = action.discountedPrice;
        update[productIndex].buyX = action.buyX;
        update[productIndex].percentage = action.percentage;
        update[productIndex].promo = action.promo;
        return update;
      }
      case 'clean': {
        const update = [];
        return update;
      }
      case 'getQuantity': {
        const cart = [...state];
      }
      default:
        return state;
    }
  }

  function add(product) {
    if (!(cartQuantity >= MAXCARTNUM)) {
      const index = stat?.prod.findIndex((item) => item._id === product._id);
      if (index >= 0) {
        stat.prod[index].add_to_cart = stat.prod[index].add_to_cart += 1;
      } else {
        stat.prod.push({
          _id: product._id,
          detail: 0,
          specs: 0,
          includes: 0,
          name: product.name?.en,
          add_to_cart: 1,
          conv: 0,
        });
      }
      setStat(stat);
      console.log(stat);
    }

    setCart({ product, type: 'add' });
  }

  function remove(product) {
    setCart({ product, type: 'remove' });
  }

  function alterQuantity(product, quantity, isIncrement) {
    setCart({ product, type: 'chgQuantity', quantity: quantity });
  }

  function cleanUp() {
    setCart({ type: 'clean' });
    setProds({ type: 'clean' });
  }

  function changePrice(product, discount, discountedPrice, buyX, percentage, promo) {
    setCart({
      product,
      type: 'changePrice',
      discount: discount,
      discountedPrice: discountedPrice,
      buyX: buyX,
      percentage: percentage,
      promo: promo,
    });
  }

  function idleScreenSaver() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/slider') !== 0 &&
      window.location.pathname.indexOf('/machineUI/home/') !== 0
    ) {
      return <IdleTimer machine={machine} idle={idle} />;
    } else {
      return null;
    }
  }

  function disability() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/payment') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0
    ) {
      return <Disability />;
    } else {
      return null;
    }
  }
  // navigator.onLine ? (
  return (
    <div className="App">
      {idleScreenSaver()}
      {disability()}
      <CartFullModal show={cartFull} setCartFull={setCartFull} />
      <UserContext.Provider
        value={{
          loginStatus,
          setLoginStatus,
          userName,
          user,
          setUser,
          setUserName,
          role,
          setRole,
          userEmail,
          setUserEmail,
          referTo,
          setReferTo,
          fullAccess,
          setFullAccess,
          machineID,
          setMachineID,
          setTestMode,
          testMode,
          stat,
          setStat,
        }}
      >
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route
              exact
              path="/machineUI/slider/:id/"
              render={(props) => (
                <ImageSlider
                  stat={stat}
                  cleanUp={cleanUp}
                  defaultStat={defaultStat}
                  setStat={setStat}
                  id={props.match.params.id}
                  linkPromo={linkPromo}
                  cartQuantity={cartQuantity}
                  setLinkPromo={setLinkPromo}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/homePage/:id"
              render={(props) => (
                <Home
                  stat={stat}
                  setStat={setStat}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  id={props.match.params.id}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  setCartFull={setCartFull}
                  setlangs={setlangs}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product/:machineID/:id/:index"
              render={(props) => (
                <DescriptionPage
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  id={props.match.params.id}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  i={props.match.params.index}
                  setCartFull={setCartFull}
                />
              )}
            />

            <Route
              exact
              path="/machineUI/category/:brandOrCate/:catename/:id"
              render={(props) => (
                <CategoryPage
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  machineID={props.match.params.id}
                  catename={props.match.params.catename}
                  id={props.match.params.id}
                  brandOrCate={props.match.params.brandOrCate}
                  setCartFull={setCartFull}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/home/:id/:test"
              render={(props) => (
                <Initial
                  stat={stat}
                  setStat={setStat}
                  setLinkPromo={setLinkPromo}
                  linkPromo={linkPromo}
                  setShowCart={setShowCart}
                  setlangs={setlangs}
                  setTestMode={setTestMode}
                  setMachine={setMachine}
                  setProds={setAllProds}
                  id={props.match.params.id}
                  test={props.match.params.test}
                  cleanUp={cleanUp}
                />
              )}
            />

            <Route
              exact
              path="/machineUI/payment/:id"
              render={(props) => (
                <PaymentPrompt
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/selectPayment/:id"
              render={(props) => (
                <SelectPayment
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/cashPayment/:id"
              render={(props) => (
                <CashPayment
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product-dispense/:id"
              render={(props) => (
                <ProductDispense
                  linkPromo={linkPromo}
                  langs={langs}
                  stat={stat}
                  setStat={setStat}
                  id={props.match.params.id}
                  machine={machine}
                  cart={cart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/emailCode/:id"
              render={(props) => (
                <EmailCode langs={langs} id={props.match.params.id} machine={machine} />
              )}
            />
            <Route
              exact
              path="/machineUI/out-of-order/:id"
              render={(props) => <OutOfOrder id={props.match.params.id} />}
            />
            <Route exact path="/machineSignIn/:page" component={MachineSignIn} />
            <Route exact path="/machineSignIn" component={MachineSignIn} />
            <Route exact path="/synch" render={(props) => <Synch loginStatus={loginStatus} />} />
            <Route path="/logout" component={Logout} />
            <Route component={NotFound} />
          </Switch>
        </AnimatePresence>
      </UserContext.Provider>
    </div>
  );
  // ) : (
  //   <NoInt />
  // );
}

export default App;
